import type { Theme, Components } from '@mui/material/styles';

import { motion } from '../../motion';

// ----------------------------------------------------------------------

// MUI Menu uses Grow (origin-aware — scales from the trigger); tune timing only.
const MuiMenu: Components<Theme>['MuiMenu'] = {
  // ▼▼▼▼▼▼▼▼ ⚙️ PROPS ▼▼▼▼▼▼▼▼
  defaultProps: {
    transitionDuration: { enter: motion.durationMs.fast, exit: motion.durationMs.instant },
    TransitionProps: { easing: motion.ease.out },
  },
};

const MuiMenuItem: Components<Theme>['MuiMenuItem'] = {
  // ▼▼▼▼▼▼▼▼ 🎨 STYLE ▼▼▼▼▼▼▼▼
  styleOverrides: {
    root: ({ theme }) => ({
      ...theme.mixins.menuItemStyles(theme),
    }),
  },
};

/* **********************************************************************
 * 🚀 Export
 * **********************************************************************/
export const menu: Components<Theme> = {
  MuiMenu,
  MuiMenuItem,
};
